import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clearShapesFn } from 'src/components/ZoneEditor/context';
import { QUERY_KEY_MAP } from 'src/constants';
import { useNotification, useSearch } from 'src/hooks';
import {
  removeDetectionZonesPromise,
  RemoveDetectionZonesSchema,
} from 'src/utils/api/edit-detection-zone/removeDetectionZonePromise';

export const useRemoveDetectionZones = () => {
  const queryClient = useQueryClient();
  const { enqueueSuccessNotification } = useNotification();
  const [searchParams] = useSearch();
  const deviceId = searchParams?.device?.id || '';

  const { mutateAsync, isPending, isError, error } = useMutation({
    mutationFn: removeDetectionZonesPromise,
  });

  const removeDetectionZonesAsync = async (params: RemoveDetectionZonesSchema) => {
    try {
      await mutateAsync(params);

      clearShapesFn();

      enqueueSuccessNotification('Zones removed');

      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetZoneLastUpdatedMeta, deviceId],
        }),

        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetDetectionZoneData, deviceId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetDeviceZoneVersionHistory, deviceId],
        }),
      ]);
    } catch (e) {
      console.error(e);
    }
  };

  return { removeDetectionZonesAsync, isLoading: isPending, isError, error };
};
